import $ from 'jquery';

const initInfluencerShareLink = (function() {
  function openInfluenceShareModal(data) {
    const json = parseRtn(data);
    $.modal({
      url: '/r/dialog/InfluencerShare.jsp?product=' + influencerShareLink.singleProduct + '&surl=' + encodeURIComponent(json.surl) + '&wurl=' + encodeURIComponent(json.wurl),
      triggerOpen: true,
      type: 'small',
      returnFocus: '#rShareLinkButton',
    })
  }

  let ambassadorActiveCopyLink = false;

  const influencerShareLink = window.rcProps.influencerShareLink;

  function copyToClipboardIS() {
    if (ambassadorActiveCopyLink) {
      return;
    }
    ambassadorActiveCopyLink = true;
    if ($("#bShareLinkURL").val() === '') {
      const callURL = influencerShareLink.endpoint + '?l=' + encodeURIComponent(window.location.href);
      $.ajax({
        type: 'GET',
        data: {shareProducts: influencerShareLink.shareProducts},
        url: callURL,
        async: false,
        success: function (data) {
          $("#bShareLinkURL").val(data.toString());
          openInfluenceShareModal(data.toString());
        }
      });
    } else {
      const newval = $("#bShareLinkURL").val();
      openInfluenceShareModal(newval);
    }
    ambassadorActiveCopyLink = false;
  }

  return function() {
    window.copyToClipboardIS = copyToClipboardIS;
  }
})();

export default initInfluencerShareLink;



// WEBPACK FOOTER //
// ./src/scripts/modules/influencer-share-link.js